import { QuickFiltersValueDisplayUses } from '../../types/quickFilters/QuickFiltersValueDisplayUses';
import DisplayValueAssociation from 'customer-data-filters-ui/components/display/DisplayValueAssociation';
import QuickFiltersTags from './QuickFiltersTags';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useStrategy } from '../../hooks/useStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickFiltersAssociationValueDisplay = props => {
  const {
    condition,
    onValueDelete,
    use
  } = props;
  const {
    data,
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getValueResolver
  } = useStrategy();
  const {
    value
  } = condition;
  const getFamilyValueResolver = getValueResolver.bind(null, baseFilterFamily);
  const label = /*#__PURE__*/_jsx(DisplayValueAssociation, {
    operator: condition,
    data: data,
    filterFamily: baseFilterFamily,
    getFamilyValueResolver: getFamilyValueResolver
  });
  if (use === QuickFiltersValueDisplayUses.STRING) {
    return label;
  }
  const tags = [{
    value: value ? value.toString() : '',
    label
  }];
  return /*#__PURE__*/_jsx(QuickFiltersTags, {
    tags: tags,
    onTagClose: () => onValueDelete()
  });
};
export default QuickFiltersAssociationValueDisplay;